import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { Link } from '@wartek-id/link'
import { Button } from '@wartek-id/button-v1'
import { Separator } from '@wartek-id/separator'
import { Spinner } from '@wartek-id/spinner'
import { Text } from '@wartek-id/text-v1'

import { useApiCompetencyMappingCertificate } from 'api/competency-mapping/useAPICompetencyMapping'
import {
  CPKvKeys,
  useGetCPKeyPairValue,
} from 'api/content-platform/useAPIKeyValue'
import { useSETrackEvent } from '../hooks/useSETrackEvent'
import PdfPreviewer from './PdfPreviewer'
import { useMediaQueryHelper } from '../hooks/useMediaQueryHelper'
import { useApiUserDetailProfile } from 'api/competency-mapping/useAPIUserDetail'

import type { IUjikomPeriodData } from 'types/content-platform'

const CertificatePageContent = ({
  isUjikomWhitelisted,
}: {
  isUjikomWhitelisted: boolean
}) => {
  const assesmentType = 'SJT'
  const router = useRouter()
  const { isDesktop } = useMediaQueryHelper()

  const { trackCertificatePage } = useSETrackEvent()

  const configPemKomPeriod = useGetCPKeyPairValue<IUjikomPeriodData>(
    CPKvKeys.UjikomPeriodContent,
    isUjikomWhitelisted
  )

  const { data: profileData, isLoading: isLoadingProfile } =
    useApiUserDetailProfile(assesmentType, { enabled: isUjikomWhitelisted })

  const { data: certificateData, isLoading: isLoadingCertificate } =
    useApiCompetencyMappingCertificate(assesmentType, isUjikomWhitelisted, {
      onError() {
        router.replace('/pemetaan-kompetensi') // TODO Handle errors
      },
    })

  const trackerProps = (): any => {
    return {
      pemKomPeriod:
        !configPemKomPeriod.isLoading && configPemKomPeriod.isSuccess
          ? configPemKomPeriod?.data?.data
          : null,
    }
  }

  useEffect(() => {
    const { pemKomPeriod } = trackerProps()

    trackCertificatePage({
      pemKomPeriod,
      activityType: 'OPEN_PEMKOM_CERTIFICATE_PAGE',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const RenderUserData = ({ data }) => {
    const fieldsMappingLabel = {
      name: 'Nama',
      nip: 'NIP',
      emailBid: 'Akun belajar.id',
      educationUnitName: 'Satuan Pendidikan',
    }
    return (
      <>
        {Object.entries(fieldsMappingLabel).map((thisEntry, thisKey) => (
          <div key={`dat_${thisKey}`}>
            <div className="inline-block py-5 break-words max-w-full">
              <Text as="span" className="inline-block mr-1">
                {thisEntry[1]}:
              </Text>
              <Text as="span" variant="body-bold">
                {data?.[thisEntry[0]]}
              </Text>
            </div>
            {thisKey < Object.keys(fieldsMappingLabel).length - 1 && (
              <Separator orientation="horizontal" />
            )}
          </div>
        ))}
      </>
    )
  }

  const browserDownload = async (link: string) => {
    const a = document.createElement('a')
    a.href = link
    a.target = '_blank'
    a.setAttribute('download', 'file')

    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  if (isLoadingProfile || isLoadingCertificate)
    return (
      <div className="w-full flex justify-center">
        <Spinner />
      </div>
    )

  return (
    <>
      <div className="mt-5 mb-1 justify-items-center place-content-center flex flex-auto">
        <PdfPreviewer data={certificateData?.url} isRemoteUrl />
      </div>
      <div className="flex-col flex-grow bg-white m-4 px-4 rounded-md ">
        {profileData && <RenderUserData data={profileData.data} />}
      </div>
      <div className="bg-white mx-4 p-4 rounded-md ">
        <Text variant="heading-md">Pastikan data Anda sesuai</Text>
        <div className="text-left text-[15px] mt-2 ujikom-panduan-wysiwyg ol">
          Pastikan sesuai sebelum unduh sertifikat. Jika tidak sesuai, klik
          <Link
            href="https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/articles/17265294031641"
            underline={false}
            variant="primary"
            className="!pr-0 font-bold"
          >
            tautan ini
          </Link>
          .
        </div>
      </div>
      <div className="bottom-0 py-5 px-4 w-full">
        <Button
          disabled={
            isLoadingProfile || isLoadingCertificate || !certificateData?.url
          }
          size="lg"
          fullWidth={!isDesktop}
          className="float-right"
          onClick={() => {
            const { pemKomPeriod } = trackerProps()

            trackCertificatePage({
              pemKomPeriod,
              activityType: 'CLICK_DOWNLOAD_CERTIFICATE_BUTTON',
            })

            browserDownload(certificateData?.url)
          }}
        >
          Unduh sertifikat
        </Button>
      </div>
    </>
  )
}

export default CertificatePageContent
